import homeReducer from "./homeReducer";
import iletisimReducer from "./iletisimReducer";
import duyurularReducer from "./duyurularReducer";
import sakinlerReducer from "./sakinlerReducer";
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    homeData: homeReducer,
    iletisimData: iletisimReducer,
    duyurularData: duyurularReducer,
    sakinlerData: sakinlerReducer
});
export default rootReducer;
